import { TOUR_TRANSLATIONS } from "../translations"

export const getOffersDetailsSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="offers-details-filters"]',
            title: t.offersDetailsFilters.title,
            content: t.offersDetailsFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="offers-details-table"]',
            title: t.offersDetailsTable.title,
            content: t.offersDetailsTable.content,
        },
    ]
}
